import axios from "axios";

const axiosConfig = {
  baseURL: `https://${process.env.REACT_APP_API_BASE_URL}`,
  headers: {
    "Content-Type": "application/json",
  },
};

export const http = axios.create(axiosConfig);
